import type { BadgeVariations } from '@synqo/frontend-component-library';
import { EnumRequisitionStatus } from './Generated';

export function getEnumRequisitionStatusLabel(value: EnumRequisitionStatus) {
    switch (value) {
        case EnumRequisitionStatus.Open:
            return 'Offen';
        case EnumRequisitionStatus.InProgress:
            return 'In Bearbeitung';
        case EnumRequisitionStatus.UnderReview:
            return 'Wird geprüft';
        case EnumRequisitionStatus.Rejected:
            return 'Abgelehnt';
        case EnumRequisitionStatus.Completed:
            return 'Abgeschlossen';
        default:
            return 'Nicht definiert';
    }
}

export function getBadgeVariantByRequisitionStatus(value: EnumRequisitionStatus): BadgeVariations {
    switch (value) {
        case EnumRequisitionStatus.Open:
            return 'default';
        case EnumRequisitionStatus.InProgress:
            return 'warning';
        case EnumRequisitionStatus.UnderReview:
            return 'accent';
        case EnumRequisitionStatus.Rejected:
            return 'danger';
        case EnumRequisitionStatus.Completed:
            return 'info';
        default:
            return 'danger';
    }
}
